import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import getScoreTypeDetails from 'src/app/shared/utils/score-type-details';
import { ChatChartsEventsDataService } from './chat-charts-events-data.service';
import { EventMention } from './chat-charts-events.models';

@Component({
  selector: 'app-chat-charts-events',
  templateUrl: './chat-charts-events.component.html',
  styleUrls: ['./chat-charts-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatChartsEventsComponent implements OnChanges, OnDestroy {
  @Input() childEvent: string;
  @Input() childEventScore: string;
  @Input() childEventsTimeframe: string;

  events: EventMention[] = [];
  loading = false;
  error = false;
  noData = false;

  private destroy$ = new Subject<void>();

  constructor(
    private eventsDataService: ChatChartsEventsDataService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['childEvent'] ||
      changes['childEventScore'] ||
      changes['childEventsTimeframe']
    ) {
      this.loadEvents();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAbsDelta(event: EventMention): number {
    return Math.abs(event.delta || 0);
  }

  isDeltaPositive(event: EventMention): boolean {
    return (event.delta || 0) >= 0;
  }

  hasDelta(event: EventMention): boolean {
    return event.delta !== undefined && event.delta !== 0;
  }

  private loadEvents(): void {
    if (!this.childEvent || !this.childEventScore) {
      return;
    }

    this.loading = true;
    this.error = false;
    this.noData = false;
    this.cdr.markForCheck();

    const scoreKey =
      getScoreTypeDetails(this.childEventScore).scoreKey ||
      this.childEventScore;

    this.eventsDataService
      .fetchEventMentions(
        this.childEvent,
        scoreKey,
        this.childEventsTimeframe || '7',
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (events) => {
          this.events = events
            .filter((e) => e.contrib_amount > 0)
            .sort((a, b) => b.contrib_amount - a.contrib_amount)
            .slice(0, 10);

          this.noData = this.events.length === 0;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.error = true;
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
